'use strict';

var Accordion$1 = require('./src/Accordion.js');
var AccordionItem = require('./src/AccordionItem.js');

const Accordion = Accordion$1.Accordion;
Accordion.Item = AccordionItem.Item;

exports.Accordion = Accordion;
//# sourceMappingURL=index.js.map
